import React from 'react';
import { useTranslation } from 'react-i18next';

const GridClient = ({ gridText, formGrid, userGrid, gridCols, textBlock }) => {
  const { t } = useTranslation();
  let numCol = '';

  switch (gridCols) {
    case 1:
      numCol = 'grid-cols-1';
      break;
    case 2:
      numCol = 'grid-cols-2';
      break;
    case 3:
      numCol = 'grid-cols-3';
      break;
    default:
      numCol = 'grid-cols-4';
      break;
  }

  return (
    <>
      {gridText && (
        <h3 className="pt-4 pl-4 text-2xl font-bold text-blue-600">
          {gridText}
        </h3>
      )}
      <div className="w-full bg-slate-100 text-lg font-bold rounded-2xl mt-4 pl-4">
        {textBlock}
      </div>
      <div className={`bg-blue-50 grid ${numCol} gap-6 rounded-2xl mt-1 p-4`}>
        {formGrid?.map((input, key) => (
          <div className="text-left" key={key}>
            <div className="font-bold text-blue-900">{t(input.label)}</div>
            <div>
              {userGrid?.[input?.id]}
              {userGrid?.[input?.id + 'Url'] &&
                userGrid?.[input?.id] === 'Yes' &&
                userGrid?.[input?.id + 'Url'].length === 0 && (
                  <div className="text-red-600">MISSING</div>
                )}
              {userGrid?.[input?.id + 'Url'] &&
                userGrid?.[input?.id + 'Url'].map((e, i) => {
                  return (
                    <div key={i}>
                      <a
                        className="text-blue-500"
                        href={e.urlDownloadFile}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {e.name}
                      </a>
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
        {textBlock === 'Employment Expenses' && (
          <>
            <div className="text-left grid grid-cols-1 gap-6 w-full border-b rounded-xl">
              {/* <div className="font-bold text-blue-900">
                {t('expensesText.daysWorkedFromHome')}
              </div>
              <div className="text-black">
                {userGrid?.employmentExpensesFlatMethodDays
                  ? userGrid?.employmentExpensesFlatMethodDays
                  : ''}
              </div> */}
            </div>
            <div className="text-left grid grid-cols-1 gap-6 w-full">
              <div className="font-bold text-blue-900">
                List the expenses you are claiming and the amount.
              </div>
              <div className="text-black">
                {userGrid?.employmentExpensesDetailedMethodDescribe
                  ? userGrid?.employmentExpensesDetailedMethodDescribe
                  : ''}
              </div>
            </div>
          </>
        )}

        {textBlock === 'Partner Employment Expenses' && (
          <>
            {/*             <div className="p-4 text-left grid grid-cols-1 gap-6 w-full border-b rounded-xl">
              <div className="font-bold text-blue-900">
                {t('expensesText.daysWorkedFromHome')}
              </div>
              <div className="text-black">
                {userGrid?.PartnerEmploymentExpensesFlatMethodDays
                  ? userGrid?.PartnerEmploymentExpensesFlatMethodDays
                  : ''}
              </div>
            </div> */}
            <div className="p-4 text-left grid grid-cols-1 gap-6 w-full">
              <div className="font-bold text-blue-900">
                List the expenses you are claiming and the amount.
              </div>
              <div className="text-black">
                {userGrid?.PartneremploymentExpensesDetailedMethodDescribe
                  ? userGrid?.PartneremploymentExpensesDetailedMethodDescribe
                  : ''}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default GridClient;
